export const USER = {
    userId: 1,
    personId: 1,
    userName: `jacob`,
    email: `jacob@smartrak.co.nz`,
    permissions: {
        canCreateBooking: true
    },
};



// WEBPACK FOOTER //
// ./scripts/constants/fakeData/user.js